import { IEnvironment } from '@environments/IEnvironment';

/**
 * Fetches the environment configuration from the API.
 * The API is always located at the same origin under /api/angular/environment.
 * For local development, this is proxied to the actual environment.
 */
export async function getEnvironment(): Promise<IEnvironment> {
  const response = await fetch('/api/angular/environment', { credentials: 'omit' });

  if (!response.ok) {
    throw new Error(
      `Failed to load environment configuration: ${response.status} ${response.statusText}`
    );
  }

  return response.json();
}
